import React from 'react';
import CloseablePage from '../CloseablePage';
import ChangePasswordWithData from '../../components/ChangePassword/ChangePasswordWithData';

function ChangePasswordPage() {
  return (
    <CloseablePage>
      <ChangePasswordWithData />
    </CloseablePage>
  );
}

export default ChangePasswordPage;



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordPage/index.js